// Concept relevant breakpoints
// For more info, see: https://zpl.io/bomQ0JM
export const BREAKPOINT_360 = '360'
export const BREAKPOINT_600 = '600' // global breakpoint
export const BREAKPOINT_720 = '720' // gutter change 16px => 24px
export const BREAKPOINT_760 = '760' // global breakpoint
export const BREAKPOINT_840 = '840'
export const BREAKPOINT_1000 = '1000' // gutter change 24px => 32px
export const BREAKPOINT_1280 = '1280' // global breakpoint
